import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';

import { CamtlSecurityComponent } from './security.component';
import { ColsAdminComponent } from './cols-admin/cols-admin.component';
import { SuperUserComponent } from './super-user/super-user.component';

@NgModule({
    imports: [
        SharedModule,
    ],
    declarations: [
        CamtlSecurityComponent,
        ColsAdminComponent,
        SuperUserComponent,
    ],

})
export class CamtlSecurityModule { }
